import { render } from "./musica_fondo.vue?vue&type=template&id=36a34bd9&scoped=true"
import script from "./musica_fondo.vue?vue&type=script&lang=js"
export * from "./musica_fondo.vue?vue&type=script&lang=js"

import "./musica_fondo.vue?vue&type=style&index=0&id=36a34bd9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a34bd9"]])

export default __exports__